export const KidsContentSliderData = [
  {
    id: 1,
    src: '/images/Kids/alphabet.jpg',
    alt: 'list-img',
  },
  {
    id: 2,
    src: '/images/Kids/ball.jpg',
    alt: 'list-img',
  },
  {
    id: 3,
    src: '/images/Kids/block.jpg',
    alt: 'list-img',
  },
  {
    id: 4,
    src: '/images/Kids/camera.JPG',
    alt: 'list-img',
  },
  {
    id: 5,
    src: '/images/Kids/children.jpg',
    alt: 'list-img',
  },
  {
    id: 6,
    src: '/images/Kids/colorPencil.jpg',
    alt: 'list-img',
  },
  {
    id: 7,
    src: '/images/Kids/handPainting.jpg',
    alt: 'list-img',
  },
  {
    id: 8,
    src: '/images/Kids/jump.jpg',
    alt: 'list-img',
  },
  {
    id: 9,
    src: '/images/Kids/marvel.JPG',
    alt: 'list-img',
  },
  {
    id: 10,
    src: '/images/Kids/play.jpg',
    alt: 'list-img',
  },
  {
    id: 11,
    src: '/images/Kids/rainbow.jpg',
    alt: 'list-img',
  },
  {
    id: 12,
    src: '/images/Kids/sandCastle.jpg',
    alt: 'list-img',
  },
];
